export const ldlPlaylist = [
  'alertHeadlines',
  'now',
  'todayTonight',
  'tomorrow',
  'hourly',
  'pollen',
  'airQuality',
  'sunriseSunset',
  'twoDay',
  'threeDay',
];
